<app-toolbar-popover *ngIf="isRecordingOrPause && !isSpinning"
  [displayMode]="getDisplayMode"
  [collapsedButton]="collapsedButtonItem"
  [expandedButtons]="expandedButtonItems">
</app-toolbar-popover>

<div *ngIf="!popOverOpen && isNotRecordingOrPauseOrUploadingVideo"
    class="button-container"
    [soti-tooltip]="'remoteControl_btn_RecordVideo_Processing' | xsI18n "
    placement="left"
    [ngClass]="{'button-container-disabled': isVideoRecordingButtonDisabled()}"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">

    <div *ngIf="recordingWithAudioEnabled && !isSpinning" class="hd-icon hd-icon-toolbarpointer icon-lg toolbarpointer-icon scale50-with-same-origin"></div>

    <div class="hd-icon hd-icon-recordVideo icon-lg popover-icon"
        [class.active]="false"></div>
    <span
        class="hd-icon-mic mic-badge hd-icon"
        [style.visibility]="recordingWithAudio ? 'visible' : 'hidden'"></span>
    <mat-spinner
        class="button-spinner"
        [diameter]=30
        [strokeWidth]=2
        *ngIf="isSpinning"></mat-spinner>
</div>
<div *ngIf="popOverOpen && isNotRecordingOrPauseOrUploadingVideo"
    class="popover-container popover-container-box">
    <div class="hd-icon hd-icon-recordVideo icon-lg popover-icon"
        [soti-tooltip]="'remoteControl_btn_RecordVideo' | xsI18n "
        [placement]="expandedButtonsVisibleCount > 1 || recordingWithAudioEnabled ? 'top' : 'left'"
        [class.active]="isRecording"
        [class.over]="popOverOpen"
        (mouseover)='mouseOverAudio = false'
        [class.video-plus]="mouseOverAudio"
        (click)="startRecording(false)"></div>
    <div class="hd-icon hd-icon-plus icon-lg popover-icon plus-icon"
        *ngIf="recordingWithAudioEnabled"
        [class.active]="isRecording && mouseOverAudio"
        [class.over]="mouseOverAudio"
        [style.visibility] = "mouseOverAudio ? 'visible' : 'hidden'"></div>
    <div class="hd-icon hd-icon-mic icon-lg popover-icon mic-icon"
        [soti-tooltip]="'remoteControl_btn_RecordVideoWithVoice' | xsI18n "
        placement="left"
        *ngIf="recordingWithAudioEnabled"
        [class.active]="isRecording && mouseOverAudio"
        [class.over]="mouseOverAudio"
        (mouseover)='mouseOverAudio = true'
        (click)="startRecording(true)"></div>
</div>
